var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "box" },
    [
      _vm.accion.finalizada
        ? _c("span", { staticClass: "tag is-pulled-right is-success" }, [
            _vm._v("Hecho"),
          ])
        : _c("span", { staticClass: "tag is-pulled-right is-warning" }, [
            _vm._v("Pendiente"),
          ]),
      _vm._v(" "),
      _c("h1", { staticClass: "title is-6 has-text-primary" }, [
        _c("i", { staticClass: "fas fa-info-circle" }),
        _vm._v(" \n      "),
        _c("span", {}, [
          _vm._v(_vm._s(_vm.accion.documento_accion.descripcion)),
        ]),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "subtitle is-6" }, [
        _vm._v(
          _vm._s(
            _vm.getOperacion(_vm.accion.documento_accion.documento_operacion_id)
              .nombre
          )
        ),
      ]),
      _vm._v(" "),
      _vm.isAnexarSubunidad && !_vm.accion.finalizada
        ? _c("anexar-subunidad", {
            attrs: {
              "accion-id": _vm.accion.id,
              parametros: _vm.accion.documento_accion.parametros,
            },
            on: { updateDocument: _vm.updateDocument },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isFirmarPdfSubunidad && !_vm.accion.finalizada
        ? _c("firmar-pdf-subunidad", {
            attrs: {
              "accion-id": _vm.accion.id,
              parametros: _vm.accion.documento_accion.parametros,
            },
            on: { updateDocument: _vm.updateDocument },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isCargarAspectoCompuesta && !_vm.accion.finalizada
        ? _c("cargar-aspecto-compuesta", {
            attrs: {
              "accion-id": _vm.accion.id,
              parametros: _vm.accion.documento_accion.parametros,
            },
            on: { updateDocument: _vm.updateDocument },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }